import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import { t } from '../../../i18n';
import UrlTo from '../../../url-to';
import { arrowDownPointerIcon, logoutIcon, userIcon } from '../../assets/index';
import UserAvatar from '../user-avatar';
import './styles.scss';

const ProfileDesktopNavbar = ({ user, onLogout }) => {
  const [showPopover, setShowPopover] = useState(false);

  const renderPopover = () => (
    <Popover className="courses-header__profile-wrapper-popover courses-header__profile-wrapper-popover_desktop">
      <Link to={UrlTo.coursesProfile()} onClick={() => setShowPopover(false)}>
        <img src={userIcon} alt="user" />
        <b>{t('DIGITAL_COURSES.HEADER.MY_ACCOUNT')}</b>
      </Link>
      <Link
        to="#"
        onClick={() => {
          onLogout();
          setShowPopover(false);
        }}
      >
        <img src={logoutIcon} alt="logout" />
        <b>{t('DIGITAL_COURSES.HEADER.LOGOUT')}</b>
      </Link>
    </Popover>
  );

  return (
    <div
      className="courses-header__profile-wrapper courses-header__profile-wrapper_desktop"
      onClick={() => setShowPopover(!showPopover)}
    >
      <div className="courses-header__profile-icon-wrapper courses-header__profile-icon-wrapper_desktop">
        <UserAvatar photoUrl={user.photo} userName={user.name} />
      </div>
      <div>
        <b>{user.name}</b>
        <p>
          {user.email}
          <OverlayTrigger show={showPopover} placement="bottom" overlay={renderPopover()}>
            <span className="courses-header__profile-popover-pointer">
              <img src={arrowDownPointerIcon} alt="arrow-down-pointer" />
            </span>
          </OverlayTrigger>
        </p>
      </div>
    </div>
  );
};

export default ProfileDesktopNavbar;
